import { apiClient } from './api'

// ── Types ──────────────────────────────────────────────────

export interface StockItemView {
  structureId: string
  structureName: string
  structureCode: string
  stockType: string
  itemType: 'blood' | 'medication'
  quantity: number
  minQuantity: number
  unit: string
  alertLevel: string
  status: 'OK' | 'WARNING' | 'CRITICAL'
}

// ── API Calls ──────────────────────────────────────────────

export const stocksApi = {
  getBlood: async (): Promise<StockItemView[]> => {
    const res = await apiClient.get<StockItemView[]>('/api/v1/stocks?type=blood')
    return res.data
  },

  getMedications: async (): Promise<StockItemView[]> => {
    const res = await apiClient.get<StockItemView[]>('/api/v1/stocks?type=medication')
    return res.data
  },
}
